import React, { useState, useEffect } from 'react';
import commonService from 'src/service/common';
import { useLocation } from 'react-router-dom';
import {  subServices} from '../../../models/sideBar';
import goodalipi from 'src/plugins/goodalipi';

const SupersetDashboard = () => {
    const [entitykey, setEntityKey] = useState('');
    const [dashboardId, setDashboardId] = useState(0);
    const user = goodalipi.get('user');
    const authtoken = user?.accessToken?.longToken || '';

    const location = useLocation();
    let currentPath = location.pathname;

    useEffect(() => {
        setSupersetUrlParams();
    }, [currentPath]);

    const setSupersetUrlParams = () => {
        let entitykey = commonService.getEntityKey();
        setEntityKey(entitykey);
        
        Object.entries(subServices).forEach(([key, value]) => {
            if (value.href == currentPath){
                setDashboardId(value.dashboardId);
            }
        });

        return;
    }

    return (
        <div style={{
            height: '95%',
            marginTop: '15px',
            marginLeft: '15px',
            marginRight: '10px',
        }}>
            {
                (entitykey && dashboardId) ?
                    <div style={{
                        border: '1px solid black',
                        height: "100%",
                        borderRadius: '16px'
                    }}>
                        <iframe
                            src={`https://superset-hrwin-ui.medibuddy.in?entitykey=${entitykey}&dashboardId=${dashboardId}&authtoken=${encodeURIComponent(authtoken)}`}
                            width="100%"
                            height="100%"
                            title="Dashboard Content"
                            frameBorder="0"
                            style = {{
                                borderRadius: '16px'
                            }}
                        ></iframe>
                    </div>
                    :
                    <div style={{
                        textAlign: 'center',
                        color: 'red',
                        fontSize: '20px',
                        fontWeight: 'bold'
                    }}>
                        Failed to load the dashboard...
                    </div>
            }
        </div>
    );
}

export default SupersetDashboard;